import { Stack, Tabs } from '@mantine/core'
import { LinkTab } from '@ui/LinkTab'
import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router'

type Tab = {
    link: string
    name: string
}

const tabs: Tab[] = [
    {
        name: 'SAR - Curriculum',
        link: '/reports/sar/curriculum'
    },
    {
        name: 'SAR - Pastoral',
        link: '/reports/sar/pastoral'
    },
    {
        name: 'Destinations',
        link: '/reports/destinations'
    }
]

export const Route = createFileRoute('/_layout/reports')({
  component: RouteComponent,
})

function RouteComponent() {
    const matchRoute = useMatchRoute()
    const activeTab = tabs.find((tab) => matchRoute({ to: tab.link as never }))?.link ?? null

  return (
        <Stack gap={0} h={'100%'} w={'100%'}>
            <Tabs value={activeTab}>
                <Tabs.List>
                    {tabs.map((tab) => (
                        <LinkTab key={tab.name} to={tab.link as never} value={tab.link}>
                            {tab.name}
                        </LinkTab>
                    ))}
                </Tabs.List>
            </Tabs>
            <Outlet />
        </Stack>
  );
}
